export default __webpack_public_path__ + "static/media/logo-header.dbcb95e2.svg";